import { None } from "@siteimprove/alfa-option";
import { String } from "@siteimprove/alfa-string";
import { Node } from "../node.js";
/**
 * @remarks
 * Containers are structural element with no interesting semantic.
 * They correspond to elements with no "interesting" property, for this a role
 * of `generic` is considered as not interesting.
 * Because `generic` can also be containers, they may still have a role.
 * Because `generic` have prohibited names, and having an `aria-*` property
 * is "interesting", Container don't need a name or attributes.
 *
 * @public
 */
export class Container extends Node {
    static of(owner, children = [], role = None) {
        return new Container(owner, Array.from(children), role);
    }
    _role;
    constructor(owner, children, role) {
        super(owner, children, "container");
        this._role = role;
    }
    clone(parent = None) {
        return new Container(this._node, this._children.map((child) => child.clone()), this._role);
    }
    get role() {
        return this._role;
    }
    isIgnored() {
        return true;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            role: this._role.map((role) => role.name).getOr(null),
        };
    }
    toString() {
        return [
            "container",
            ...this._children.map((child) => String.indent(child.toString())),
        ].join("\n");
    }
}
//# sourceMappingURL=container.js.map